module.exports = __webpack_public_path__ + "img/15mg-mektovi.87e69a80.png";